import { AxiosError, AxiosInstance } from 'axios';

const IDEMPOTENT_METHODS = ['get', 'head', 'options', 'put', 'delete'];
const MAX_RETRIES = 2;
const RETRY_DELAY_MS = 1000;

const isNetworkError = (error: AxiosError): boolean =>
  !error.response && !!error.config && error.code === AxiosError.ERR_NETWORK;

const isIdempotentMethod = (method?: string): boolean =>
  IDEMPOTENT_METHODS.includes((method ?? '').toLowerCase());

export const createTransientRetryInterceptor = (instance: AxiosInstance) => {
  return async (error: AxiosError): Promise<unknown> => {
    const config = error.config as AxiosError['config'] & {
      __retryCount?: number;
    };

    if (
      !config ||
      !isNetworkError(error) ||
      !isIdempotentMethod(config.method)
    ) {
      throw error;
    }

    const retryCount = config.__retryCount ?? 0;

    if (retryCount >= MAX_RETRIES) {
      throw error;
    }

    config.__retryCount = retryCount + 1;

    await new Promise((resolve) =>
      setTimeout(resolve, (retryCount + 1) * RETRY_DELAY_MS),
    );

    return instance.request(config);
  };
};
